import globalsService from 'Services/globalsService'

const ShowAlert = (message, variant) => {
  return globalsService.getShowAlert()(message, variant)
}

export default ShowAlert
